const CardProbabilities = ({
  currentWeek,
  currentWeekPlus4,
  probs,
  maxProbsIndex,
  pricesDiff4Weeks,
  hideRealTrend = false,
}) => {
  const getRealTrendText = (trend) => {
    switch (trend) {
      case "up":
        return "⬆";
      case "down":
        return "⬇";
      case "maintain":
        return "〓";
      default:
        return undefined;
    }
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case "up":
        return "rgb(15, 178, 0)";
      case "down":
        return "rgb(179, 48, 48)";
      case "maintain":
        return "rgb(214, 159, 7)";
      default:
        return "rgb(142, 142, 142)";
    }
  };

  return (
    <div
      style={{
        width: "fit-content",
      }}
    >
      <span
        style={{
          display: "block",
          fontWeight: "bold",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {currentWeek}º ➟ {currentWeekPlus4}º
      </span>
      <div
        style={{
          visibility: `${pricesDiff4Weeks ? "visible" : "hidden"}`,
          display: hideRealTrend ? "none" : "block",
          marginBottom: "5px",
          border: `solid 2px ${getTrendColor(pricesDiff4Weeks)}`,
          borderRadius: "5px",
          whiteSpace: "nowrap",
          padding: "2px 5px",
          color: getTrendColor(pricesDiff4Weeks),
          backgroundColor:
            maxProbsIndex === pricesDiff4Weeks
              ? `rgba(${getTrendColor(pricesDiff4Weeks)
                  .match(/\d+/g)
                  .join(", ")}, 0.1)`
              : "transparent",
          textAlign: "right",
          fontWeight: maxProbsIndex === pricesDiff4Weeks ? "bold" : "normal",
        }}
      >
        Real: {getRealTrendText(pricesDiff4Weeks)}
      </div>
      <div
        style={{
          border: `solid ${
            maxProbsIndex === "up"
              ? `2px ${getTrendColor("up")}`
              : "1px rgb(191, 191, 191)"
          }`,
          borderTopRightRadius: "5px",
          borderTopLeftRadius: "5px",
          whiteSpace: "nowrap",
          padding: "2px 5px",
          color:
            maxProbsIndex === "up" ? getTrendColor("up") : "rgb(142, 142, 142)",
          backgroundColor:
            maxProbsIndex === "up"
              ? `rgba(${getTrendColor("up").match(/\d+/g).join(", ")}, 0.1)`
              : "transparent",
          textAlign: "right",
          fontWeight: maxProbsIndex === "up" ? "bold" : "normal",
        }}
      >
        {(probs.up * 100).toFixed(0)}% ⬆
      </div>
      <div
        style={{
          border: `solid ${
            maxProbsIndex === "maintain"
              ? `2px ${getTrendColor("maintain")}`
              : "1px rgb(191, 191, 191)"
          }`,
          whiteSpace: "nowrap",
          padding: "2px 5px",
          color:
            maxProbsIndex === "maintain"
              ? getTrendColor("maintain")
              : "rgb(142, 142, 142)",
          backgroundColor:
            maxProbsIndex === "maintain"
              ? `rgba(${getTrendColor("maintain")
                  .match(/\d+/g)
                  .join(", ")}, 0.1)`
              : "transparent",
          textAlign: "right",
          fontWeight: maxProbsIndex === "maintain" ? "bold" : "normal",
        }}
      >
        {(probs.maintain * 100).toFixed(0)}% 〓
      </div>
      <div
        style={{
          border: `solid ${
            maxProbsIndex === "down"
              ? `2px ${getTrendColor("down")}`
              : "1px rgb(191, 191, 191)"
          }`,
          borderBottomRightRadius: "5px",
          borderBottomLeftRadius: "5px",
          whiteSpace: "nowrap",
          padding: "2px 5px",
          color:
            maxProbsIndex === "down"
              ? getTrendColor("down")
              : "rgb(142, 142, 142)",
          backgroundColor:
            maxProbsIndex === "down"
              ? `rgba(${getTrendColor("down").match(/\d+/g).join(", ")}, 0.1)`
              : "transparent",
          textAlign: "right",
          fontWeight: maxProbsIndex === "down" ? "bold" : "normal",
        }}
      >
        {(probs.down * 100).toFixed(0)}% ⬇
      </div>
    </div>
  );
};

export default CardProbabilities;
